<div class="footer desktop">

    <div class="p-col-12 pd-0">
        <div class="footer desktop body">
            <div class="footer-container">

                <div class="footer-btn" (click)="getManualSchool()">
                    <div class="footer-label">
                        中学校・高校等向け<br>利用マニュアル
                    </div>
                </div>

                <div class="footer-btn" (click)="getManualSupport()">
                    <div class="footer-label">
                        保育所・幼稚園等向け<br>利用マニュアル
                    </div>
                </div>

                <div class="footer-btn" (click)="moveContact()">
                    <div class="footer-label">
                        お問い合わせ
                    </div>
                </div>

                <div class="footer-btn" (click)="movePrivacy()">
                    <div class="footer-label">
                        プライバシー<br>ポリシー等
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="footer mobile">
  <div class="footer-container body">
    <div class="footer-row">
      <div class="footer-btn" (click)="getManualSchool()">
        <div class="footer-label">
          中学校・高校等向け<br>利用マニュアル
        </div>
      </div>
      <div class="footer-btn" (click)="getManualSupport()">
        <div class="footer-label">
          保育所・幼稚園等向け<br>利用マニュアル
        </div>
      </div>
    </div>
    <div class="footer-row">
      <div class="footer-btn" (click)="moveContact()">
        <div class="footer-label">
          お問い合わせ
        </div>
      </div>
      <div class="footer-btn" (click)="movePrivacy()">
        <div class="footer-label">
          プライバシー<br>ポリシー等
        </div>
      </div>
    </div>
  </div>
</div>